import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingDirections, OrderingOption } from 'generated/graphql-types';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { CallCostsFilterOption } from '../models/call-cost-filter-option';
import { CallCostRegisterOptions } from '../models/call-cost-register-options';
import { CallCostRegisterListItem } from '../models/call-cost-register-results.model';
import * as CallCostRegisterActions from './call-cost-register.actions';

export const callCostsRegisterFeatureKey = 'callCostsRegister';

export interface CallCostRegisterState
   extends RegisterState<CallCostRegisterListItem, CallCostRegisterOptions, OrderingOption> {
   filters: CallCostsFilterOption[];
}

const adapter: RegisterAdapter<CallCostRegisterListItem, CallCostRegisterOptions, OrderingOption> =
   createRegisterAdapter<CallCostRegisterListItem, CallCostRegisterOptions, OrderingOption>({
      selectId: (CallCostRegisterItem) => {
         return CallCostRegisterItem.providerCallRateId ?? 0;
      },
   });

export const initialState: CallCostRegisterState = {
   ...adapter.getInitialState(),
   filters: [],
   orderingOptions: [{ direction: OrderingDirections.Asc, field: 'providerTypeName' }],
};

export const CallCostRegisterReducer = adapter.createReducer(
   CallCostRegisterActions.callCostRegisterAdapterActions,
   initialState,
   on(CallCostRegisterActions.callCostRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: null,
      };
   }),
   on(CallCostRegisterActions.callCostRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
         endCursor: action.endCursor,
         hasNextPage: action.hasNextPage,
         totalCount: action.totalCount,
      };
   }),
   on(CallCostRegisterActions.callCostRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         filters: action.filters,
      };
   }),
   on(CallCostRegisterActions.callCostRegisterAdapterActions.quickFilterChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: {
            ...state.quickFilters,
            ...action.quickFilters,
         },
      };
   }),
   on(CallCostRegisterActions.callCostRegisterAdapterActions.orderingOptionsChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         orderingOptions: state.orderingOptions
            ? [
                 ...state.orderingOptions
                    .filter((option) => !action.orderingOptions.some((newOption) => newOption.field === option.field))
                    .filter((option) => option.direction !== OrderingDirections.NotSet),
                 ...action.orderingOptions,
              ]
            : action.orderingOptions,
      };
   })
);
export const callCostRegisterSelector = createFeatureSelector<CallCostRegisterState>(callCostsRegisterFeatureKey);
export const selectors = adapter.getSelectors(callCostRegisterSelector);
export const {
   selectAll,
   selectCallState,
   selectTotalCount,
   selectQuickFilters,
   selectEndCursor,
   selectOrderingOptions,
} = adapter.getSelectors(callCostRegisterSelector);
